import React, {cloneElement} from "react";
import { RCCLov } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { ILovSelectFirstOption } from "../interface";

const LovCostCenter: React.FC<ILovSelectFirstOption> = ({
	name,
	control,
	label,
	extraParametersOnLoad,
	setValue,
	...rest
}) => {
	const { translate } = useTranslation();
	const optionComponent = (component:any,props:any) =>  cloneElement(
		component,
		props,
		<span style={{marginLeft: `${(props.data.extendedProps.level - 1) * 16}px`}}>{props.data.label}</span>
	);
	  
	return(
		<RCCLov 
			label={label}
			name={name} 
			control={control}
			routeAPI="CostCenter/Lov"
			valueProperty="Id"
			labelProperty="Description"
			elementsPerPage={20}
			extraParametersOnLoad={extraParametersOnLoad || {
				budgetPlanId: 0,
				subsidiaryId: ""
			}}
			componentsFunctions={{option:(x,y) => optionComponent(x,y)}}
			selectFirstOption={setValue ? {
				setValueForm: setValue 
			} : undefined}
			placeholder={translate("Digite para filtrar as opções")}
			{...rest}
		/>
	);
};

export default LovCostCenter;
